import React, { useContext, useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import search1 from "../../../Components/assets/icons/search.png";
import Offcanvas from "react-bootstrap/Offcanvas";
// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";

import {
  Row,
  Col,
  Form,
  InputGroup,
  Modal,
  Table,
  Button,
  Container,
} from "react-bootstrap";
import { useForm } from "react-hook-form";
import classNames from "classnames";

import Pagination_Holder from "../../common/Pagination_Holder/Pagination_Holder";
const moment = require("moment");
library.add(fas);

const AddOffCanvance = (props) => {
  const id = props.show;
  const { postData, getData, IMG_URL, Select2Data, editStatusData } =
    useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const calculateTimeAgo = (date) => {
    const createdAt = new Date(date);
    const now = new Date();
    const diffInMilliseconds = now - createdAt;

    const diffInMinutes = Math.floor(diffInMilliseconds / 60000);
    const diffInHours = Math.floor(diffInMilliseconds / (1000 * 60 * 60));
    const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));

    if (diffInDays >= 1) {
      return `${diffInDays} Day${diffInDays > 1 ? "s" : ""} Ago`;
    } else if (diffInHours >= 1) {
      return `${diffInHours} Hour${diffInHours > 1 ? "s" : ""} Ago`;
    } else {
      return `${diffInMinutes} Min Ago`;
    }
  };

  const formatTimeInIST = (date) => {
    const createdAt = new Date(date);
    const options = { hour: "2-digit", minute: "2-digit", hour12: true };
    const istTime = createdAt.toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      ...options,
    });
    // setFormattedTime(`${istTime} IST`);
    return istTime;
  };

  const handleDateChange = (e) => {
    setDate(e.target.value);
  };

  const [data, setCategories] = useState([]);
  const [paymentData, setPaymentData] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [store_id, setStoreId] = useState({});
  const [date, setDate] = useState("");
  const [searchDate, setSearchDate] = useState("");
  const [searchInvoice, setSearchInvoice] = useState("");
  const [searchStatus, setSearchStatus] = useState(null);
  const [searchDateTo, setSearchDateTo] = useState("");
  const [searchDateFrom, setSearchDateFrom] = useState();
  const [search, setSearch] = useState("");
  const [expertStatusData, setExpertStatusData] = useState([]);
  const [isResetting, setIsResetting] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, settotalPages] = useState();
  const [onPageChange, setonPageChange] = useState(1);
  const [perPage, setperPage] = useState(10);
  const GetEditData = async () => {
    const response = await getData(
      `/admin/expert/orders/expertorder/${id}?page=${onPageChange}&per_page=${perPage}&store_id=${store_id?.value || ""}&from_date=${searchDateFrom || ""}&to_date=${searchDateTo || ""}&invoice_no=${searchInvoice || ""}&expert_order_status_id=${searchStatus?.value || ""}`,
    );
    if (response?.success) {
      setCategories(response?.data);
      setCurrentPage(response?.data?.current_page);
      setperPage(response?.data?.per_page);
      settotalPages(response?.data?.total_pages);
    }
  };

  useEffect(() => {
    GetEditData();
  }, [onPageChange]);
  const getAllExpertStatus = async () => {
    try {
      const response = await getData("/common/masters/all-expertStatus");

      if (response?.success) {
        setExpertStatusData(response?.data?.data || []);
      } else {
        setExpertStatusData([]);
      }
    } catch (error) {
      console.error("Error fetching expert status list:", error);
      setExpertStatusData([]);
    }
  };
  useEffect(() => {
    getAllExpertStatus();
  }, []);

  const GetPaymentMethodData = async () => {
    const response = await getData(`/admin/expert/order/${id}`);
    if (response?.success) {
      setPaymentData(response?.data);
    }
  };

  useEffect(() => {
    GetEditData();
    GetPaymentMethodData();
  }, [
    props.show,
    // searchDateFrom, searchDateTo, searchInvoice, searchStatus,
  ]);

  const [today, setToday] = useState("");
  useEffect(() => {
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split("T")[0]; // YYYY-MM-DD format
    setToday(formattedDate);
  }, []);

  const calculateTotalAmount = () => {
    if (Array.isArray(data)) {
      return data
        .reduce((total, order) => {
          return total + parseFloat(order.total_amount || 0);
        }, 0)
        .toFixed(2);
    }
    return 0;
  };

  const formatTo12Hour = (dateTime) => {
    if (!dateTime) return "";

    return new Date(dateTime).toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const [showModalPayment, setShowModalPayment] = useState();
  const [paymentInput, setPaymentInput] = useState("");

  const handleOpen = () => {
    setShowModalPayment(id);
  };
  const handleClose = () => setShowModalPayment(false);

  const handleReset = async () => {
    setSearch("");
    setSearchDateFrom("");
    setSearchDateTo("");
    setSearchInvoice("");
    setSearchStatus(null);
    setIsResetting(true);
  };

  useEffect(() => {
    if (isResetting) {
      GetEditData();
      setIsResetting(false);
    }
  }, [isResetting]);

  const handlePageChange = (pageNumber) => {
    setonPageChange(pageNumber);
  };
  return (
    <>
      <Offcanvas
        show={props.show}
        style={{ width: "80%", height: "auto" }}
        placement={"end"}
        onHide={props.handleClose}
        className="offcan"
      >
        <div className="tabss-main">
          <Offcanvas.Header closeButton></Offcanvas.Header>
          <Offcanvas.Body>
            <div className="AddOffCanvance_page p-3">
              <div className="page-header d-flex justify-content-between align-items-center mb-4">
                <h3>Order List</h3>
              </div>
              <div>
                <div className="package-details-section mb-3">
                  <Row>
                    <div>
                      <Row>
                        <Col md={5}>
                          <label className="form-label">Start Date</label>
                          <input
                            type="date"
                            className="form-control"
                            placeholder="from"
                            value={searchDateFrom}
                            onChange={(e) => {
                              setSearchDateFrom(e.target.value);
                            }}
                          />
                        </Col>
                        <Col md={5}>
                          <label className="form-label">End Date</label>
                          <input
                            type="date"
                            className="form-control"
                            placeholder="to"
                            value={searchDateTo}
                            onChange={(e) => {
                              setSearchDateTo(e.target.value);
                            }}
                          />
                        </Col>

                        <Col md={5}>
                          <label className="form-label">Invoice</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="invoice No"
                            value={searchInvoice}
                            onChange={(e) => {
                              setSearchInvoice(e.target.value);
                            }}
                          />
                        </Col>

                        <Col md={5}>
                          <label className="form-label">Status</label>
                          <Select
                            options={expertStatusData}
                            value={searchStatus}
                            placeholder="Select status"
                            onChange={(selectedOption) =>
                              setSearchStatus(selectedOption)
                            }
                            isClearable
                            classNamePrefix="react-select"
                          />
                        </Col>

                        <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2 d-flex gap-3 align-items-end">
                          <div className="Search me-2">
                            <Button
                              type="button"
                              onClick={GetEditData}
                              className="btn btn-search"
                            >
                              <img src={search1} className="search" alt="" />
                            </Button>
                          </div>
                          <div className="Search-1">
                            <button
                              type="button"
                              onClick={handleReset}
                              className="btn btn-reset"
                            >
                              Reset
                            </button>
                          </div>
                        </div>
                      </Row>
                    </div>
                  </Row>

                  <div className="row mt-4"></div>

                  <hr />
                  <h4>Order Details</h4>
                  <div className="pending-table_holder">
                    <Table striped bordered hover responsive center>
                      <thead>
                        <tr className="">
                          <th className="sr">Sr. No.</th>
                          <th className="sr">Date/Time</th>
                          <th className="tax-name">Invoice No </th>
                          {/* <th className="tax-name">Store</th> */}
                          <th className="tax-name">Status </th>
                          <th className="active">Address</th>
                          <th className="sr">Customer Details </th>
                          <th className="active">Amount </th>
                          {/* <th className="active">Delivery Charges</th> */}
                          {/* <th className="active">Delivery Boy Charges</th> */}
                          {/* <th className="active">Payment Status </th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {data &&
                          data?.data?.map((d, index) => {
                            return (
                              <tr className="" key={index}>
                                <td>{index + 1}.</td>
                                <td>
                                  {" "}
                                  {/* <div className="order-id">
                                {calculateTimeAgo(d?.updatedAt)}
                              </div> */}
                                  <div className="order-info">
                                    {new Date(d?.updatedAt).toLocaleDateString(
                                      "en-CA",
                                    )}
                                  </div>
                                  <div className="order-info">
                                    <span>{formatTo12Hour(d?.updatedAt)} </span>
                                  </div>
                                </td>
                                <td>
                                  {
                                    d?.Order_Assign_Expert?.Order_Detail
                                      ?.invoice_no
                                  }
                                </td>
                                {/* <td>{d?.Store_Detail?.store_name}</td> */}
                                <td>{d?.Expert_Order_Status?.name} </td>

                                <td>
                                  <strong>Drop Area : </strong>
                                  {d?.Drop_Area?.name}{" "}
                                  {/* {d?.User_Address?.first_name}{" "}
                              {d?.User_Address?.last_name} */}
                                  <div>
                                    <strong>Pickup Area : </strong>
                                    {d?.Pickup_Area?.name}{" "}
                                    {/* {d?.User_Address?.building} building ,
                                {d?.User_Address?.apartment} ,{" "}
                                {d?.User_Address?.street} */}
                                  </div>
                                  <div>{d?.User_Address?.contact_no}</div>
                                </td>

                                <td>
                                  Name :{" "}
                                  {
                                    d?.Order_Assign_Expert?.Order_Detail?.User
                                      ?.name
                                  }
                                  <br></br>
                                  Contact No :{" "}
                                  {
                                    d?.Order_Assign_Expert?.Order_Detail?.User
                                      ?.contact_no
                                  }
                                </td>

                                <td>
                                  {" "}
                                  {Number(
                                    d?.Order_Assign_Expert?.Order_Detail
                                      ?.total_amount || 0,
                                  ).toFixed(2)}
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </Table>
                    {data && data?.data?.length > 0 ? (
                      <Pagination_Holder
                        onPageChange={currentPage}
                        totalPages={totalPages}
                        handlePageChange={handlePageChange}
                      />
                    ) : (
                      <p className="no-datashow">Sorry, No Data Found</p>
                    )}
                    {/* {data && data?.length < 1 && (
                      <Row className="mt-5 pb-3">
                        <div className="d-flex justify-content-center">
                          <h4> No Data Found </h4>
                        </div>
                      </Row>
                    )} */}
                  </div>
                </div>
              </div>

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"Close"}
                      handleClose={props.handleClose}
                    />
                  </Link>
                </div>
              </Row>
            </div>

            <ModalSave
              message={showModal.message}
              showErrorModal={showModal.code ? true : false}
            />
          </Offcanvas.Body>
        </div>
      </Offcanvas>
    </>
  );
};

export default AddOffCanvance;
